import styled from 'foundations-theming/utils';
import { SkeletonText } from './SkeletonText';
export const ShinySkeletonText = styled(SkeletonText).withConfig({
  displayName: "skeletonHelpers__ShinySkeletonText",
  componentId: "sc-80trvi-0"
})(["background:", ";background:linear-gradient( to right,", ",", " 20%,", " 40% );background-size:1200px;"], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.color['fill-field-default']);
export const ShinySkeletonTextBody = styled(SkeletonText).withConfig({
  displayName: "skeletonHelpers__ShinySkeletonTextBody",
  componentId: "sc-80trvi-1"
})(["background:", ";background:linear-gradient( to right,", ",", " 20%,", " 40% );background-size:1200px;width:", ";"], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.color['fill-field-default'], ({
  width
}) => width);
export const ShinySkeletonCircle = styled.div.withConfig({
  displayName: "skeletonHelpers__ShinySkeletonCircle",
  componentId: "sc-80trvi-2"
})(["background:", ";background:linear-gradient( to right,", ",", " 20%,", " 40% );background-size:1200px;background-color:", ";border-radius:50%;height:", "px;width:", "px;"], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  size
}) => size, ({
  size
}) => size);